import styles from './Avatar.module.css';

const COLORS = ['#e34a2a', '#5a8ab8', '#c79a3a', '#5a6a2a', '#8a6ac8', '#7ec9a8'];

type AvatarSize = 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
const SIZES: Record<AvatarSize, number> = { sm: 28, md: 36, lg: 52, xl: 56, xxl: 80 };

function hashName(name: string): number {
  let h = 0;
  for (let i = 0; i < name.length; i++) {
    h = ((h << 5) - h + name.charCodeAt(i)) | 0;
  }
  return Math.abs(h);
}

interface AvatarProps {
  name: string;
  size?: AvatarSize;
  status?: 'online' | 'busy' | 'idle' | 'offline';
  className?: string;
  imageUrl?: string;
  presetColor?: string;
  noTexture?: boolean;
}

const STATUS_COLORS: Record<string, string> = {
  online: '#4CAF50',
  busy: '#D94F3B',
  idle: '#F5A623',
  offline: '#9E9E8E',
};

export function Avatar({ name, size = 'md', status, className, imageUrl, presetColor, noTexture }: AvatarProps) {
  const px = SIZES[size];
  const color = presetColor || COLORS[hashName(name) % COLORS.length];
  const initial = name.charAt(0).toUpperCase();
  const dotSize = size === 'sm' ? 8 : size === 'lg' ? 12 : 10;

  return (
    <div
      className={`${styles.avatar} ${noTexture ? styles.noTexture : ''} ${className || ''}`}
      style={{
        width: px,
        height: px,
        backgroundColor: imageUrl ? 'transparent' : color,
        fontSize: px * 0.42,
      }}
    >
      {imageUrl ? (
        <img src={imageUrl} alt={name} className={styles.avatarImg} />
      ) : (
        initial
      )}
      {status && (
        <span
          className={styles.statusDot}
          style={{
            width: dotSize,
            height: dotSize,
            backgroundColor: STATUS_COLORS[status],
          }}
        />
      )}
    </div>
  );
}
